import * as React from 'react';
import { IAThemeCard } from './card/Card';
import { inject, observer } from 'mobx-react';
import { ThemeStore } from './../stores';
import { ITheme } from '../../../interfaces/ITheme';

export interface IThemeCardViewProps {
  themeStore?: ThemeStore;
}

@inject('themeStore')
@observer
export default class ThemeCardView extends React.Component<IThemeCardViewProps> {
  constructor(props) {
    super(props);
  }

  private skeletonCards(): JSX.Element[] {
    let skeletonCards = [];
    for (let i = 0; i < 15; i++) {
      skeletonCards.push(
        <IAThemeCard
          key={i}
          showSkeleton={true}
        />
      );
    }
    return skeletonCards;
  }

  private showCards(): JSX.Element[] {
    let cards: JSX.Element[] = [];
    for (let i = 0; i < this.props.themeStore.themes.length; i++) {
      cards.push(
        <IAThemeCard
          key={this.props.themeStore.themes[i].Name}
          item={this.props.themeStore.themes[i]}
          select={() => {
            this.props.themeStore.openTheme(this.props.themeStore.themes[i]);
          }}
          onClickEdit={(item: ITheme) => {
            this.props.themeStore.editTheme(item);
          }}
          onClickOpen={(item: ITheme) => {
            this.props.themeStore.openTheme(item);
          }}
          onClickDelete={(item: ITheme) => {
            this.props.themeStore.deleteTheme(item);
          }}
        />
      );
    }
    return cards;
  }

  public render(): JSX.Element {
    return (
      <div
        style={{
          width: "100%",
          height: "100%"
        }}
      >
        {!this.props.themeStore.loading ? this.showCards() : this.skeletonCards()}
      </div>
    );
  }
}